import React from "react";
import { Crown } from "lucide-react";

const GlobalAdminIcon = (props: any) => <Crown {...props} />;

export default GlobalAdminIcon;
